export default __webpack_public_path__ + "static/media/Skoda Auto2 - Logo.829fbfe6.png";